// date-fns tokens:
// https://date-fns.org/v2.22.1/docs/format
//
// Java Simple Date Format tokens:
// https://docs.oracle.com/javase/7/docs/api/java/text/SimpleDateFormat.html

import { FormatConverter } from 'cadenza/utils/date-time/format-converter';

const formatMapping = {
  u: 'i'
};

const formatConverter = new FormatConverter(formatMapping);

export function convertJavaToDateFnsDateFormat (javaFormat) {
  return formatConverter.convert(javaFormat);
}
